module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-cloak",
    style: (_vm.computedStyle)
  }, [_c('erco-spinner', {
    class: ['spinner', {
      '-vcenter': _vm.vCenter
    }],
    attrs: {
      "size": "60px"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf8609fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoCloak.vue
// module id = 672
// module chunks = 0